var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "main-container",
      class: _vm.colorMode === "dark" ? "dark-block" : "",
    },
    [
      _c("h2", [
        _vm._v("Is compliance strong enough in your African supply chains?"),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Ethics 1st developed by the Center for International Private\n    Enterprise (CIPE) not only avoids risks of check-box compliance but also\n    provides capacity building tailored to African SMEs.\n  "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "action-wrap" }, [
        _c(
          "a",
          {
            staticClass: "cta-button",
            class: _vm.colorMode === "light" ? "medium-button" : "",
            on: { click: _vm.openLink },
          },
          [_vm._v("Ethics 1st")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }